'use client'

import HeaderGap from '@/components/atoms/headerGap'
import Layout from '@/components/templates/layout'
import CoverAnimation from '@/components/organisms/coverAnimation'
import Info from './components/info'
import AboutUs from './components/aboutUs'
import OurApproach from './components/ourApproach'
import OurTeam from './components/ourTeam'
import ImageSpacer from './components/imageSpacer'
import Community from '@/components/organisms/community'

const AboutPage = ({ aboutAPI, footerAPI, settingAPI }) => {

  return (
    <Layout settingAPI={settingAPI} footerAPI={footerAPI}>
      <HeaderGap />
      <CoverAnimation
        option={aboutAPI.cover.option}
        images={aboutAPI.cover.images}
        video={aboutAPI.cover.video}
        imagePlaceholder={aboutAPI.cover.imagePlaceholder}
        aspectRatio={aboutAPI.cover.aspectRatio}
        rowOne={aboutAPI.cover.title.rowOne}
        rowTwo={aboutAPI.cover.title.rowTwo}
      />
      <Info text={aboutAPI.info} />
      <AboutUs
        title={aboutAPI.about.title}
        description={aboutAPI.about.description}
        image={aboutAPI.about.image}
      />
      <OurApproach
        title={aboutAPI.approach.title}
        description={aboutAPI.approach.description}
        image={aboutAPI.approach.image}
      />
      <OurTeam founders={aboutAPI.team.founders} teams={aboutAPI.team.teams} />
      <ImageSpacer image={aboutAPI.imageSpacer} />
      <Community
        title={settingAPI.community.title}
        description={settingAPI.community.description}
        image={settingAPI.community.image}
        ctaButton={settingAPI.community.ctaButton}
      />
    </Layout>
  )
}

export default AboutPage
